const formatters = new Map();

const getFormatter = (language, options) => {
  const key = `${language}:${JSON.stringify(options)}`;
  if (!formatters.has(key)) {
    formatters.set(key, new Intl.DateTimeFormat(language, options));
  }
  return formatters.get(key);
};

export const formatDay = (dateValue, language) =>
  getFormatter(language, {
    weekday: "short",
  }).format(dateValue);

export const formatMonth = (dateValue, language, expanded = false) =>
  getFormatter(language, {
    month: expanded ? "long" : "short",
    // year: "numeric",
  }).format(dateValue);
